export default "__VITE_ASSET__f80b5cb1__"